
export const SEARCH_CREATE = 'SEARCH_CREATE';
export const SEARCH_READ = 'SEARCH_READ';
export const SEARCH_UPDATE = 'SEARCH_UPDATE';
export const SEARCH_DELETE = 'SEARCH_DELETE';

export function updateSearch(searchState) {
  let type = SEARCH_UPDATE;
  return({ type, payload: searchState });
}



// WEBPACK FOOTER //
// ./src/redux/actions/search.js